import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        // Não rola para o topo quando o usuário está voltando (botão voltar / navigate(-1))
        // para permitir restauração de posição de scroll em páginas como /produtos
        if (navigationType !== 'POP') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [pathname, navigationType]);

    return null;
}
